import { InformativeBanner } from 'app/src/shared/components'
import { getFunnelDiscount } from 'app/src/shared/helpers'
import { useWebAppContext } from 'app/src/shared/hooks'
import { useTranslation } from 'react-i18next'

export function InformativeBannerSection() {
  const context = useWebAppContext()
  const { t } = useTranslation('userInfo', { keyPrefix: 'UserInfo.InformativeBannerSection' })
  const funnelDiscount = getFunnelDiscount(context)

  if (funnelDiscount.onlyDiscount) return <></>

  return <InformativeBanner title={t('Title')} text={t('Text')} />
}
